import axios from 'axios';


export const getSimple = (mwe, exact, page = 1, sort = '-freq') => {
  return axios.get('/api/search/simple-lema', {
    params: {
      mwe: mwe.toLowerCase(),
      exact_form: exact,
      page: page,
      sort,
    }
  })
};

export const getAdvanced = (coll, w1, w2, w3, page = 1, sort = '-freq') => {
  return axios.get('/api/search/advanced-lema', {
    params: {
      coll,
      w1,
      w2,
      w3,
      page,
      sort,
    }
  })
};

